import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'conversation/{id}/messages';

const conversationMessagesQueryKey = (conversationId: string) => [BASE_QUERY_KEY, conversationId];

export const useConversationMessagesInfiniteQuery = ({
	conversationId,
	pageSize = 25,
	enabled = true,
	refetchOnWindowFocus,
	type,
}: {
	conversationId: string;
	pageSize?: number;
	enabled?: boolean;
	refetchOnWindowFocus?: boolean;
	type?: string;
}) => {
	const userSession = useUserSession();
	return useInfiniteQuery<Api.IPagedCollection<Api.ITextMessage>>({
		enabled,
		getNextPageParam: lastPage => lastPage.pageToken,
		queryFn: ({ pageParam }) => {
			return userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({
					queryParams: { pageToken: pageParam, pageSize },
					urlPath: `conversation/${conversationId}/messages`,
				}),
				'GET'
			);
		},
		queryKey: [...conversationMessagesQueryKey(conversationId), type, pageSize],
		refetchOnWindowFocus,
		initialPageParam: '',
	});
};

export function invalidateConversationMessages(conversationId: string) {
	return reactQueryClient.invalidateQueries({ queryKey: conversationMessagesQueryKey(conversationId) });
}

export function removeConversationMessages(conversationId: string, type: string) {
	reactQueryClient.removeQueries({ queryKey: [...conversationMessagesQueryKey(conversationId), type] });
}
